import ActionPlans from "./actionPlans";
import IndividualAction from "./individualAction";

export const tabDetails = [
  {
    label: "Action Plans",
    content: ActionPlans
  },
  {
    label: "Individual Actions",
    content: IndividualAction
  }
];
